import styled from 'styled-components';

export const MethodName = styled.div`
    font-family: ${props => props.theme.text.font.medium};
`;

export const MethodCodes = styled.div`
    font-size: ${props => props.theme.text.size.xsmall};
    color: ${props => props.theme.colors.text.secondary};

    > span {
        color: ${props => props.theme.colors.text.subtleSecondary};
    }
`;

export const RemoveCodeButton = styled.button`
    margin-left: 0.2rem;
    padding: 0.2rem 0.6rem;
    font-size: ${props => props.theme.text.size.medium};
    line-height: 1;
    color: ${props => props.theme.colors.text.subtleSecondary};
    background: transparent;
    border: none;
    border-radius: 0.3rem;
    cursor: pointer;

    &:hover {
        color: ${props => props.theme.colors.error};
        background: ${props => props.theme.colors.subtle.light};
    }
`;

export const ValidityFields = styled.div`
    display: flex;
    align-items: center;
    gap: 0.6rem;
    margin: 0.2rem 0 0.4rem;
`;

export const ValidityInput = styled.input`
    height: 2.8rem;
    padding: 0 0.6rem;
    font-size: ${props => props.theme.text.size.xsmall};
    color: ${props => props.theme.colors.text.primary};
    color-scheme: ${props => props.theme.mode};
    background: ${props => props.theme.colors.light};
    border: 0.1rem solid ${props => props.theme.colors.input.border};
    border-radius: 0.3rem;

    &:focus {
        outline: none;
        border-color: ${props => props.theme.colors.primary};
    }
`;
